// extracted by mini-css-extract-plugin
export default {"product-sidepanel-content-wrapper":"ProductSidePanel_product-sidepanel-content-wrapper__Xe3Fx"};